import { render, staticRenderFns } from "./FormularioParamsOrigen.vue?vue&type=template&id=608e2229&scoped=true"
import script from "./FormularioParamsOrigen.vue?vue&type=script&lang=js"
export * from "./FormularioParamsOrigen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e2229",
  null
  
)

export default component.exports